import { render } from "./device_detail.vue?vue&type=template&id=1368bb64&scoped=true"
import script from "./device_detail.vue?vue&type=script&lang=js"
export * from "./device_detail.vue?vue&type=script&lang=js"

import "./device_detail.vue?vue&type=style&index=0&id=1368bb64&lang=css"
import "./device_detail.vue?vue&type=style&index=1&id=1368bb64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1368bb64"]])

export default __exports__